import { Box, Button, IconButton, Menu, MenuButton, MenuList, Stack, useBreakpointValue } from "@chakra-ui/react";
import { useButtonProps, useCollectionKey, useLatestCollectionWorkflowId } from "hooks";
import type { FunctionComponent } from "react";
import React, { useContext } from "react";
import { useAddToCharliContext } from "screens/panels/addToCharli/AddToCharliWizard/AddToCharliProvider";
import { OptionsMenuItem } from "../../components/OptionsMenuItem";
import { HamburgerIcon, TriangleDownIcon } from "@chakra-ui/icons";
import { ProjectDeleteButton } from "../ProjectActions/ProjectDeleteButton";
import { useWorkflowKey } from "hooks/useWorkflows";
import { ConversationContext } from "screens/thread/ConversationContext";

interface Props {
  collectionId: string;
}

export const CompanyDetailDefaultActionMenu: FunctionComponent<Props> = ({ collectionId }) => {
  const { onProjectAddSourceOpen } = useAddToCharliContext();
  const isMobile = useBreakpointValue({ base: true, md: false, lg: false }, { fallback: "md", ssr: false });
  const commonButtonProps = useButtonProps("sm", "primary");
  const latestWorkflowId = useLatestCollectionWorkflowId(collectionId);
  const workflowStatus = useWorkflowKey(latestWorkflowId, "status");
  const { onDeleteProjectModalOpen } = useContext(ConversationContext);
  const shareDetails = useCollectionKey(collectionId, "shareDetails");
  const isSharedRead = shareDetails && shareDetails.accessMode === "read";

  return (
    <Stack direction="row" spacing="0.5rem" width="100%" justifyContent={isMobile ? "space-between" : "flex-end"}>
      <Stack direction={"row"}>
        <Box>
          <Menu isLazy>
            {isMobile ? (
              <MenuButton
                {...commonButtonProps}
                isDisabled={isSharedRead}
                as={IconButton}
                aria-label="Options"
                icon={<HamburgerIcon boxSize="1.3rem" />}
                variant="outline"
                onClick={(event) => event.stopPropagation()}
              />
            ) : (
              <MenuButton
                {...commonButtonProps}
                isDisabled={isSharedRead}
                className="ch-project-options"
                as={Button}
                aria-label="Options"
                rightIcon={<TriangleDownIcon />}
                onClick={(event) => event.stopPropagation()}>
                Actions
              </MenuButton>
            )}
            <MenuList minWidth={"unset"} zIndex={10} py="0!important">
              <OptionsMenuItem
                isDisabled={isSharedRead || workflowStatus === "in_progress"}
                menuLabel={"Add Source Content"}
                className="ch-open-add-resource-panel"
                onClick={onProjectAddSourceOpen}
              />
              <ProjectDeleteButton
                projectType="project"
                onOpenConfirmation={onDeleteProjectModalOpen}
                projectId={collectionId}
                isMenuItem
              />
            </MenuList>
          </Menu>
        </Box>
      </Stack>
    </Stack>
  );
};
